import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { api, shortAddr, formatNumber } from "@/lib/api";
import { FileCode2, CheckCircle2 } from "lucide-react";

export default function Contracts() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    api.get("/contracts", { params: { limit: 100 } })
      .then((r) => { setItems(r.data.items); setTotal(r.data.total); })
      .catch(() => { setItems([]); setTotal(0); });
  }, []);

  return (
    <Layout>
      <div className="flex items-center gap-3 mb-2">
        <FileCode2 className="text-[var(--ks-primary)]" />
        <h1 className="text-xl font-semibold" data-testid="contracts-title">Verified Contracts</h1>
      </div>
      <p className="text-sm text-[var(--ks-text-soft)] mb-4">
        {formatNumber(total)} verified contract{total === 1 ? "" : "s"} on Ethereum.
      </p>
      <div className="ks-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="ks-table" data-testid="contracts-table">
            <thead>
              <tr>
                <th>Address</th>
                <th>Name</th>
                <th>Compiler</th>
                <th>License</th>
                <th className="text-right">Optimization</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.address} data-testid={`contract-row-${c.address}`}>
                  <td>
                    <Link to={`/address/${c.address}`} className="ks-link mono flex items-center gap-1">
                      <CheckCircle2 size={14} className="text-[var(--ks-success)]" />
                      {shortAddr(c.address)}
                    </Link>
                  </td>
                  <td className="font-medium">{c.contract_name || "—"}</td>
                  <td className="text-xs">{c.compiler_version || "—"}</td>
                  <td className="text-xs">{c.license || "—"}</td>
                  <td className="text-right text-xs">
                    {c.optimization ? `Yes (${c.runs} runs)` : "No"}
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={5} className="text-center py-8 text-[var(--ks-text-soft)]">
                  No verified contracts yet. <Link to="/verify-contract" className="ks-link">Verify one →</Link>
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
